import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-catalog-router',
  template: `
    <ng-container *ngIf="componentToRender === 'product'">
      <app-product></app-product>
    </ng-container>
    <ng-container *ngIf="componentToRender === 'category'">
      <app-category></app-category>
    </ng-container>
    <ng-container *ngIf="componentToRender === 'search'">
      <app-search-results></app-search-results>
    </ng-container>
    <ng-container *ngIf="componentToRender === 'all'">
      <all-tests></all-tests>
    </ng-container>
  `
})
export class CatalogRouterComponent {
  componentToRender: 'product' | 'category' | 'search' | 'all' | null = null;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    const url = this.router.url;

    if (url.startsWith('/product')) {
      this.componentToRender = 'product';
    } else if (url.startsWith('/category')) {
      this.componentToRender = 'category';
    } else if (url.startsWith('/search')) {
      this.componentToRender = 'search';
    } else if (url.startsWith('/all')) {
      this.componentToRender = 'all';

    }
  }
}
